/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An error due to the client attempting to access a missing resource
 * @export
 * @interface NotFoundErrorResponseContent
 */
export interface NotFoundErrorResponseContent {
    /**
     * Message with details about the error
     * @type {string}
     * @memberof NotFoundErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the NotFoundErrorResponseContent interface.
 */
export function instanceOfNotFoundErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotFoundErrorResponseContentFromJSON(json: any): NotFoundErrorResponseContent {
    return NotFoundErrorResponseContentFromJSONTyped(json, false);
}

export function NotFoundErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotFoundErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function NotFoundErrorResponseContentToJSON(value?: NotFoundErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

